export default "data:text/javascript;base64,aW1wb3J0IFRTaWRlTmF2IGZyb20gIi4vVFNpZGVOYXYudnVlIjsKCmV4cG9ydCBkZWZhdWx0IFRTaWRlTmF2Owo="